import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Box as Container, Icon, Sheet } from '@node-space/ui-components'
import { useProfileContext } from 'hooks/context/useProfileContext'

export const WalletActions = () => {
  const { t } = useTranslation()
  const { viewOnly } = useProfileContext() || {}
  const [isSheetOpen, setIsSheetOpen] = useState(false)

  const handleSheetClose = () => {
    setIsSheetOpen(false)
  }

  return (
    <Container>
      <Button
        testId="buttonSend"
        disabled={viewOnly}
        onClick={() => setIsSheetOpen(true)}
        iconElement={<Icon name="ArrowUpRight" />}
      >
        {t('send')}
      </Button>

      <Sheet
        isOpen={isSheetOpen}
        header={t('wallets.sendFlowHeader')}
        setIsOpen={setIsSheetOpen}
        onClose={handleSheetClose}
      >
        {/* TODO: add flow */}
        <></>
      </Sheet>
    </Container>
  )
}
